import { Box } from '@chakra-ui/react';
import React from 'react';
import RouteWithSubRoutes, { SubRouteProps } from '../../../common/components/RouteWithSubRoutes';
import { Switch } from 'react-router-dom';

export default function Account({ routes }: SubRouteProps) {
  return (
    <Box>
      <Switch>
        {routes.map((route, i) => (
          <RouteWithSubRoutes key={i} {...route} />
        ))}
      </Switch>
    </Box>
  );
}
